import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer({ lang }) {
  return (
    <footer className="w-full py-12 border-t-8 border-white mt-16 bg-black">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="text-amber-400 font-black text-2xl uppercase tracking-tighter">
          {lang === 'en' ? 'Beer Pass' : 'Pase Cervecero'}
        </div>
        
        <div className="flex flex-wrap justify-center gap-6 font-bold uppercase text-sm">
          <Link 
            to="/" 
            className="text-white hover:text-amber-400 border-b-2 border-transparent hover:border-amber-400 transition-all pb-1"
          >
            {lang === 'en' ? 'Home' : 'Inicio'}
          </Link>
          <Link 
            to="/imprint" 
            className="text-white hover:text-amber-400 border-b-2 border-transparent hover:border-amber-400 transition-all pb-1"
          >
            {lang === 'en' ? 'Imprint' : 'Aviso Legal'}
          </Link>
          <Link 
            to="/privacy" 
            className="text-white hover:text-amber-400 border-b-2 border-transparent hover:border-amber-400 transition-all pb-1"
          >
            {lang === 'en' ? 'Privacy' : 'Privacidad'}
          </Link>
        </div>
        
        <div className="text-zinc-500 font-bold text-xs tracking-widest">
          © {new Date().getFullYear()} BEER PASS PROJECT.
        </div>
      </div>
    </footer>
  );
}